import React from "react";
import PropTypes from "prop-types";
import AtomHed from "components/source/atoms/atom-hed";
import AtomDek from "components/source/atoms/atom-dek";
import Constants from "rtr-constants";
import CalendarIcon from "images/sprites/reb/svg/superbar-calendar.svg";
import RtrParcelIcon from "images/sprites/reb/svg/rtr-parcel.svg";

const { shipsDefault } = Constants.availabilityFilter;
const { allStyles } = Constants.availabilityFilter;
const { specificDates } = Constants.availabilityFilter;

const GridSuperBarTopFiltersAvailability = props => {
  return (
    <div className="grid-availability-modal-contents">
      <AtomHed text={props.isSubscriber ? "What are you looking for?" : "Choose how you rent"} />
      <AtomDek text={props.dekText} mobileText={props.dekText} />
      <div className="availability-modal-buttons">
        <button
          className="availability-items"
          onClick={() => props.onClickBrowse(props.isSubscriber ? shipsDefault : allStyles)}>
          <RtrParcelIcon className="icon" />
          <div className="availability-items__copy">
            <p className="item-title">{props.isSubscriber ? "Subscription" : "With Subscription"}</p>
            <p>{props.isSubscriber ? "Browse items available now" : "Create shipments with 5+ items"}</p>
          </div>
        </button>
        {!props.shouldHideReserveLens && (
          <button className="availability-items" onClick={() => props.onClickBrowse(specificDates)}>
            <CalendarIcon className="icon" />
            <div className="availability-items__copy">
              <p className="item-title">{props.isSubscriber ? "One-Time Rentals" : "For Special Occasions"}</p>
              <p>{props.isSubscriber ? "Rent for 4 or 8 days" : "Book items for specific dates"}</p>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

GridSuperBarTopFiltersAvailability.propTypes = {
  dekText: PropTypes.string,
  isSubscriber: PropTypes.bool,
  onClickBrowse: PropTypes.func.isRequired,
  shouldHideReserveLens: PropTypes.bool,
};

export default GridSuperBarTopFiltersAvailability;
